import styled from "@emotion/styled"
import { Link } from "@eurodrive/utils"
import { Button, Menu, MenuItem, Typography } from "@mui/material"
import Image from "next/image"
import { useState } from "react"

import { getNonUmbracoUrl } from "@eurodrive/utils"
import { sharedColors } from "../../theme/colors"
import { MenuItemData } from "./Header"

const MenuButton = styled(Button)<{ target?: string }>`
  background-color: transparent;
  padding: 0 !important;
  margin: 0;
  min-width: 0;
  /* height: 40px; */
  height: 100%;
  border-radius: 0;
  height: 100%;
  /* & .MuiTypography-root::before {
    display: block;
    content: attr(data-content);
    font-weight: 500;
    height: 0;
    overflow: hidden;
    visibility: hidden;
  } */
`

const ButtonInner = styled.div<{ isOpen: boolean }>`
  height: 40px;
  display: flex;
  ${({ isOpen }) =>
    isOpen && `box-shadow: inset 0 -2px 0 ${sharedColors.black};`}
  :hover {
    box-shadow: inset 0 -2px 0 ${sharedColors.black};
  }
  align-items: center;
  gap: 4px;
`

const StyledLink = styled(Link)`
  text-decoration: none;
  width: 100%;
  padding: 16px;
  color: ${sharedColors.black};
  :focus-visible {
    border: 1px dashed white;
    outline-offset: 2px;
    outline: 2px solid black;
  }
`

const ActualText = styled.span<{ isBold: boolean }>`
  font-weight: ${(props) => (props.isBold ? 500 : 400)};
  white-space: nowrap;
  position: absolute;
  top: 0;
  left: 0;
`

const ReservedTypographyWrapper = styled.span`
  position: relative;
  display: inline-block;
`
const HiddenBoldText = styled.span`
  font-weight: 500;
  visibility: hidden;
  white-space: nowrap;
`

const StyledMenuButton = styled(MenuButton)`
  :focus-visible {
    border: 1px dashed white;
    outline-offset: 2px;
    outline: 2px solid black;
  }
`
interface ReservedTypographyProps {
  isBold: boolean
  children: React.ReactNode
}

function ReservedTypography({ isBold, children }: ReservedTypographyProps) {
  return (
    <ReservedTypographyWrapper>
      <HiddenBoldText>{children}</HiddenBoldText>
      <ActualText isBold={isBold}>{children}</ActualText>
    </ReservedTypographyWrapper>
  )
}

export default function NavLink({
  data,
  isOpen,
  onToggle,
  onClose,
}: {
  data: MenuItemData
  isOpen: boolean
  onToggle: () => void
  onClose: () => void
}) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const isCategory = data.items?.length > 0
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (isOpen) {
      onClose()
      setAnchorEl(null)
    } else {
      setAnchorEl(event.currentTarget)
      onToggle()
    }
  }
  const handleClose = () => {
    onClose()
    setAnchorEl(null)
  }
  return (
    <>
      {isCategory ? (
        <StyledMenuButton
          variant="text"
          disableRipple
          onClick={handleClick}
          aria-controls={isOpen ? "basic-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={isOpen ? "true" : undefined}
        >
          <ButtonInner isOpen={isOpen}>
            <Typography variant="body2">{data.label}</Typography>
            {isOpen ? (
              <Image
                src={"/icons/chevronUp.svg"}
                alt="arrow up"
                width={24}
                height={24}
              />
            ) : (
              <Image
                src={"/icons/chevronDown.svg"}
                alt="arrow down"
                width={24}
                height={24}
              />
            )}
          </ButtonInner>
        </StyledMenuButton>
      ) : (
        <StyledMenuButton
          href={
            data.href.length > 0
              ? getNonUmbracoUrl(data.href)
              : data.label.startsWith("http")
                ? data.label
                : `https://${data.href}`
          }
          LinkComponent={Link}
          disableRipple
          target={data.href.length > 0 ? "_self" : "_blank"}
        >
          <ButtonInner isOpen={isOpen}>
            <Typography variant="body2">{data.label}</Typography>
          </ButtonInner>
        </StyledMenuButton>
      )}

      <Menu
        anchorEl={anchorEl}
        open={isOpen}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        {data.items.map((item) => (
          <MenuItem key={item.label} onClick={handleClose}>
            <StyledLink
              href={`${getNonUmbracoUrl(item.href)}${item.href?.includes("contact-us") ? "?reset=true" : ""}`}
            >
              {item.label}
            </StyledLink>
          </MenuItem>
        ))}
      </Menu>
    </>
  )
}
